export { ChatContainer as CorrespondenceChat } from './components/ChatContainer';
export { CorrespondenceChatV2 } from './components/ChatContainerV2';
export { ChatContainerSimplified as CorrespondenceChatSimplified } from './components/ChatContainerSimplified';
export type { CorrespondenceChatProps } from './types';
export type { SimplifiedCorrespondenceChatProps } from './components/ChatContainerSimplified';
